import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset the window scroll position on every route change. React Router
// preserves browser-default behaviour, which means a user clicking a footer
// link halfway down a long page would land mid-page on the new route. This
// component listens for `pathname` (and search-string) changes and snaps
// back to the top.
//
// Anchor links (`/page#section`) are intentionally NOT touched — letting
// the browser's native hash-scroll handle them keeps in-page section links
// working.
//
// Mounted once at the router root (see src/routes/index.jsx). Distinct from
// src/components/ScrollToTop.jsx, which is the floating "back to top" FAB
// shown after the user has scrolled past the fold.
const ScrollResetOnNavigate = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, hash]);

  return null;
};

export default ScrollResetOnNavigate;
